import {CodeAndExchange} from "../../../../../../instruments/types/CodeAndExchange";
import {ChartWidgetConfig} from "./ChartWidgetConfig";
import {Optional} from "../../../../../../js/util/Optional";
import {ChartIQPeriodicity} from "../../../../../../components/chartiq/types/ChartIQ";

export interface ChartConfigChange {
    readonly type: ChartConfigChangeType;
}

export enum ChartConfigChangeType {
    SECURITY,
    HUD,
    PERIOD,
}

export interface ChartSecurityChange extends ChartConfigChange {
    readonly type: ChartConfigChangeType.SECURITY;
    readonly security: CodeAndExchange;
}

export function SecurityChange(security: CodeAndExchange): ChartSecurityChange {
    return {
        type: ChartConfigChangeType.SECURITY,
        security,
    };
}

export function isSecurityChange(change: ChartConfigChange): change is ChartSecurityChange {
    return change.type === ChartConfigChangeType.SECURITY;
}

export interface ChangeHudChange extends ChartConfigChange {
    readonly type: ChartConfigChangeType.HUD;
}

export function HudChange(): ChangeHudChange {
    return {
        type: ChartConfigChangeType.HUD
    };
}

export function isHudChange(change: ChartConfigChange): change is ChangeHudChange {
    return change.type === ChartConfigChangeType.HUD;
}

export interface ChartPeriodChange extends ChartConfigChange {
    readonly type: ChartConfigChangeType.PERIOD;
    readonly period: ChartIQPeriodicity;
}

export function PeriodChange(period: ChartIQPeriodicity): ChartPeriodChange {
    return {
        type: ChartConfigChangeType.PERIOD,
        period,
    };
}

export function isPeriodChange(change: ChartConfigChange): change is ChartPeriodChange {
    return change.type === ChartConfigChangeType.PERIOD;
}

export function updateConfig(change: ChartConfigChange, currentConfig: ChartWidgetConfig | null): ChartWidgetConfig {
    if (isSecurityChange(change)) {
        return {
            ...currentConfig,
            selected: change.security
        };
    } else if (isHudChange(change)) {
        const hudVisible = Optional.of(currentConfig)
                                   .map((c) => c.showHud)
                                   .orElse(false);
        return {
            ...currentConfig,
            showHud: !hudVisible
        };
    } else if (isPeriodChange(change)) {
        return {
            ...currentConfig,
            period: change.period
        };
    } else {
        return {...currentConfig};
    }
}
